/**
 * @typedef {import('./lib/react-markdown.js').ReactMarkdownOptions} Options
 * @typedef {import('./lib/ast-to-react.js').Components} Components
 */
import { ReactMarkdown } from './lib/react-markdown.js';
export { uriTransformer } from './lib/uri-transformer.js';
export default ReactMarkdown;